/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Col, Row } from "react-awesome-styled-grid";
import { Box, Button, FlexContainer, Input, theme } from "@nordcloud/gnui";
import { useQueryState } from "~/hooks";

type Props = {
  children?: React.ReactNode;
  filter?: React.ReactNode;
};

export function SearchTable({ children, filter }: Props) {
  const {
    state: { query },
    updateQueryState,
  } = useQueryState<{ query: string }>();
  const [searchInput, setSearchInput] = React.useState(query);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      updateQueryState({
        query: searchInput,
        page: 0,
      });
    }
  };

  return (
    <Box boxStyle="lightGrey" mb={theme.spacing.spacing03}>
      <Row>
        <Col md="12">
          <FlexContainer justifyContent="flex-start">
            <FlexContainer grow={1}>
              <Input
                name="input"
                placeholder="Search"
                title="Title"
                type="text"
                value={searchInput}
                onKeyDown={handleKeyPress}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setSearchInput(event.target.value)
                }
              />
            </FlexContainer>
            <Button
              severity="low"
              icon="search"
              mx="1rem"
              onClick={() =>
                updateQueryState({
                  query: searchInput,
                  page: 0,
                })
              }
            >
              Search
            </Button>
            {!!query && (
              <Button
                severity="low"
                icon="close"
                mr="1rem"
                onClick={() => {
                  setSearchInput("");
                  updateQueryState({
                    query: "",
                    page: 0,
                  });
                }}
              >
                Clear
              </Button>
            )}
            {filter}
          </FlexContainer>
          {children}
        </Col>
      </Row>
    </Box>
  );
}
